import styled from "styled-components";
import {getColorFromTheme} from "../../../utils/style.utils";
import rhombuFrameLogo from "../../../assets/images/output-onlinepngtools.png"

export const SmallDashboardWrapper = styled.div`
    overflow: hidden;
    width: 100%;
    user-select: none;
    border-radius: 12px;
    color: ${getColorFromTheme("white")};
    min-height: 140px;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: url(${rhombuFrameLogo}) repeat-x 0 0;
    background-size: 187px 187px;
    background-color: ${getColorFromTheme("secondaryColor")};
    padding: 30px;
    position: relative;
    z-index: 1;

    &:before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #20133e63, #25222d57, transparent, transparent);
        z-index: -1;
        backdrop-filter: blur(.1px);
        border-radius: inherit;
    }

    .actions {
        display: inline-flex;
        column-gap: 15px;
        align-items: center;
        justify-content: space-between;
    }

    > .balanceSect {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        flex-shrink: 0;
        text-align: left;
        gap: 4px;

        h1, h6 {
            color: #ffffff;
        }

        h6 {
            font-weight: 500;
            font-size: 14px;
        }

        h1 {
            font-weight: 700;
            font-family: SpaceGrotesk, sans-serif;
            font-size: calc(var(--step-2));
            line-height: 0%;

            > span {
                font-size: inherit;
                line-height: inherit;
                color: inherit;
            }
        }

        .balance {
            display: inline-flex;
            align-items: center;
        }

        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            flex-shrink: 0;
            align-items: center;
            row-gap: .5em;

            > .icon-btn {
                cursor: pointer;

                svg {
                    margin-inline-start: 10px;
                    color: #ffff;
                    fill: #ffff;
                    width: 1em;
                    font-size: inherit;
                }
            }
        }
    }

    .actions {
        flex-shrink: 0;

        button {
            font-size: calc(var(--step--1));
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('lg')} {
        min-height: 110px;

        .balance h1 {
            font-size: calc(var(--step-2));
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
        padding: 20px 20px;

        .actions {
            display: none;
        }

        .balanceSect .title h6.total-balance {
            font-weight: 400;
        }

        .balance h1 {
            font-weight: 600;
            font-size: 20px;
        }
    }
}`
export const Wrapper = styled.div`
    .dashboard-action {
        display: none;
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
        .dashboard-action {
            display: grid;
            gap: 15px;
        }

        .total-balance {
            font-size: 12px;
            font-family: Inter, sans-serif;
            font-weight: 400;

            .icon-btn {
                cursor: pointer;

                svg {
                    margin-inline-start: 10px;
                    color: #ffff;
                    width: 1em;
                    font-size: inherit;
                }
            }
        }

        .dashboard-action {
            button {
                padding: 12px 15px;
                font-size: var(--step--1);
            }

            //button:first-child {
            //    background-color: transparent;
            //    border: 1px solid #D0D5DD;
            //    color: black;
            //

            svg, svg * {
                stroke: #000000;
            }

            //}
            //button:last-child {
            //    background-color: #000000;
            //}
        }
    }

    .dashboard-action {
        [data-theme="dark"] & button {
            background-color: #FFFFFF;
            color: black;

            svg, svg * {
                stroke: black;
            }
        }
    }

`

